var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1107 21.6728C16.6456 22.1552 16.0557 22.4906 15.4108 22.6392L10.1937 24.2683C9.20873 24.4954 8.3263 23.5974 8.53802 22.5834L9.90856 17.0399C10.0472 16.376 10.3681 15.7668 10.8332 15.2844L24.7209 1.05262C26.0653 -0.341558 28.2553 -0.352178 29.6124 1.0289L30.9754 2.41596C32.3325 3.79704 32.3428 6.04684 30.9984 7.44102L17.1107 21.6728ZM29.2805 3.42921C30.0948 4.25786 30.101 5.60774 29.2944 6.44424L28.0624 7.72183C27.9549 7.83337 27.7797 7.83421 27.6711 7.72373L24.4771 4.47332C24.3686 4.36284 24.3677 4.18285 24.4753 4.07132L25.7072 2.79373C26.5138 1.95722 27.8278 1.95085 28.6421 2.7795L29.2805 3.42921ZM22.7533 5.85714C22.8608 5.74561 23.036 5.74476 23.1446 5.85525L26.3386 9.10565C26.4471 9.21614 26.448 9.39612 26.3404 9.50766L15.5856 20.4905C15.4926 20.5869 15.3746 20.654 15.2456 20.6838L10.8728 22.1182C10.7251 22.1523 10.5927 22.0176 10.6245 21.8655L11.8135 17.191C11.8413 17.0583 11.9054 16.9364 11.9985 16.84L22.7533 5.85714Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26582 4.4557C2.35759 4.4557 0 6.81329 0 9.72152V26.7342C0 29.6424 2.35759 32 5.26582 32H22.2785C25.1867 32 27.5443 29.6424 27.5443 26.7342V17.0127C27.5443 16.5652 27.1816 16.2025 26.7342 16.2025H25.9241C25.4766 16.2025 25.1139 16.5652 25.1139 17.0127V26.7342C25.1139 28.3001 23.8445 29.5696 22.2785 29.5696H5.26582C3.69985 29.5696 2.43038 28.3001 2.43038 26.7342V9.72152C2.43038 8.15555 3.69985 6.88608 5.26582 6.88608H15.7975C16.2449 6.88608 16.6076 6.52337 16.6076 6.07595V5.26582C16.6076 4.8184 16.2449 4.4557 15.7975 4.4557H5.26582Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.603ab16163d1e6f56f9e5d56faec36fd.svg";
export { ForwardRef as ReactComponent };